export default __webpack_public_path__ + "static/media/empty-state-trips.7db552d8.svg";